<template>
  <section :class="$style.questionsContainer">
    <Wrapper :class="$style.inner">
      <Title :class="$style.title" :title-params="content.title" />
      <ul :class="$style.list">
        <li
          v-for="(item, itemIndex) in content.list"
          :key="itemIndex"
          :class="$style.item"
        >
          <Title :class="$style.itemTitle" :title-params="item.title" />
          <RichText :class="$style.itemContent" :text-params="item.text" />
        </li>
      </ul>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import RichText from '~/components/RichText'

export default {
  name: 'Questions',

  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: this.content.list.map((faq) => {
        return {
          '@type': 'Question',
          name: faq.title[0].text,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.text[0].text,
          },
        }
      }),
    }
  },

  components: {
    Title,
    RichText,
  },

  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.questionsContainer {
  background-color: $bluko-800;
}

.inner {
  display: flex;
  flex-direction: column;
  padding: 40px 24px;

  @include above(medium) {
    padding: 80px 24px;
  }
}

.title {
  @include typo-mega-title;
  max-width: 700px;
  margin: 0 auto;

  color: white;
  font-weight: 200;
  line-height: 58px;

  text-align: center;
}

.list {
  display: grid;
  grid-gap: 40px;
  grid-template-columns: 1fr 1fr;
  margin-top: 56px;

  @include below(medium) {
    grid-gap: 20px;
    grid-template-columns: 1fr;
    margin-top: 40px;
  }
}

.item {
  &:not(:first-child) {
    margin-top: 48px;
  }

  @include above(medium) {
    flex-basis: calc(50% - 40px);

    &:not(:first-child) {
      margin-top: 0;
    }
  }
}

.itemTitle {
  @include typo-headline;
  color: white;
  font-weight: 500;
}

.itemContent {
  margin-top: 16px;

  color: $bluko-100;
}
</style>
